module.exports = __webpack_public_path__ + "img/banner.a4d463da.jpg";